<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div class="text-left" id="router" style="padding-top:3%" :style="viewStyle">
      
      <!-- Custom Status Track (Progress Bar) -->
      <div v-if="datasets.id || statusSteps.length > 0" class="status-container mb-10">
        <div v-for="(step, idx) in statusSteps" :key="idx" class="status-step step-clickable" @click="openStepPreview(step)">
          <div class="step-label">{{step.label}}</div>
          <div class="status-bubble-container">
            <div class="step-dot" :style="{ backgroundColor: step.color, borderColor: step.color }"></div>
            <div v-if="idx < statusSteps.length - 1" class="step-line"></div>
          </div>
          <div class="step-info-box">
            <div class="step-name" :style="{ backgroundColor: step.color }">{{step.name}}</div>
            <div class="step-date-time px-1 white">
              <div>{{step.date}}</div>
              <div>{{step.time}}</div>
            </div>
            <div v-if="step.files && step.files.length > 0" class="step-attachment-badge">
              <v-icon size="10" color="white">mdi-paperclip</v-icon>
              <span>{{step.files.length}}</span>
            </div>
          </div>
        </div>
        <v-btn v-if="!isReadOnly && (isManager || isAssigned)" icon color="#00BCD4" class="ml-4 bubble-plus-btn" @click="openStatusTrackDialog">
          <v-icon size="40">mdi-plus-circle</v-icon>
        </v-btn>
      </div>

      <!-- Report Section -->
      <div id="box" class="pa-5 mt-5">
        <v-row class="pb-5 align-center" style="padding: 0px 2.5% 20px 2.5%">
          <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
          <h4 class="primary-color" style="padding-top:2px">{{ $t('__sectionReport') }}</h4>
          <v-spacer></v-spacer>
          <v-btn v-if="datasets.id" icon dark class="ma-0 pa-0" style="background-color: #ED6D00; border-radius: 8px" @click="exportPdf(datasets.id, datasets.caseId, isClosedJob)">
            <div style="width: 24px; padding-top:2px">
              <v-img :src="images.PDF" alt="PDF icon"></v-img>
            </div>
          </v-btn>
        </v-row>
        
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row class="mx-2">
            <!-- Left Column -->
            <v-col class="pa-0 col-12 col-md-6">
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__customer')}}</div>
                </v-col>
                <v-col class="col-9" :class="(!isReadOnly) ? 'col-md-7' : 'col-md-8'">
                  <v-select class="text_field" dense background-color="white" outlined v-model="datasets.customer" :items="customerList" :readonly="isReadOnly" :background-color="isReadOnly?'#F4F8F9':'#FFF'" hide-details></v-select>
                </v-col>
                <v-col v-if="!isReadOnly" class="col-1 col-md-1 pa-0 mt-n2 d-flex align-center">
                  <v-btn icon color="#00BCD4" @click="addCustomer" :disabled="isReadOnly">
                    <v-icon size="40">mdi-plus-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;">{{$t('__groupRemark')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-select class="text_field" dense background-color="white" outlined v-model="datasets.groupName" :items="groupList" :readonly="isReadOnly" :background-color="isReadOnly?'#F4F8F9':'#FFF'" :clearable="!isReadOnly" hide-details></v-select>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__item')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.item" :readonly="isReadOnly" :background-color="isReadOnly?'#F4F8F9':'#FFF'" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__itemId')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.itemId" :readonly="isReadOnly" :background-color="isReadOnly?'#F4F8F9':'#FFF'" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__serialNumber')}}</div>
                </v-col>
                <v-col v-if="!isReadOnly" class="col-10 col-md-8">
                  <v-row class="ma-0">
                    <div class="autocompleteSelect" style="flex:1">
                      <v-autocomplete class="text_field autocomplete"
                      :items="deviceList" :item-text="item => `(${item.serialNumber || ''}) ${item.customer || ''}`" item-value="serialNumber" v-model="datasets.serialNumber" @change="checkWarrantyStatus"></v-autocomplete>
                    </div>
                    <div style="margin-top:0px; width: 100px">
                      <div v-if="warrantyStatus" class="under-warranty-badge" :class="warrantyStatusClass" :title="warrantyDateRange">
                        {{ displayWarrantyStatus }}
                      </div>
                    </div>
                  </v-row>
                </v-col>
                <v-col v-else class="col-10 col-md-8">
                  <v-text-field class="text_field" dense background-color="#F4F8F9" outlined v-model="datasets.serialNumber" hide-details></v-text-field>
                </v-col>

                <!-- <v-col class="col-7 col-md-5">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.serialNumber" :readonly="isReadOnly" hide-details @change="checkWarrantyStatus"></v-text-field>
                </v-col>
                <v-col class="col-3 col-md-3 pa-0 d-flex align-center pl-1" style="margin-top: -5px">
                  <div v-if="warrantyStatus" class="under-warranty-badge" :class="warrantyStatusClass" :title="warrantyDateRange">
                    {{ displayWarrantyStatus }}
                  </div>
                </v-col> -->
              </v-row>
            </v-col>

            <!-- Right Column -->
            <v-col class="pa-0 col-12 col-md-6">
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-4">
                  <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__caseId')}}</div>
                </v-col>
                <v-col class="col-10 col-md-8">
                  <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.caseId" hide-details></v-text-field>
                </v-col>
              </v-row>
              <template v-if="addNewData == 1">
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__reporter')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.creatorName" hide-details></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__createTime')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.createTimeString" hide-details></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__editor')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.editorName" hide-details></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col class="px-0 col-2 col-md-4">
                    <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__updateTime')}}</div>
                  </v-col>
                  <v-col class="col-10 col-md-8">
                    <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.updateTimeString" hide-details></v-text-field>
                  </v-col>
                </v-row>
              </template>
            </v-col>
          </v-row>

          <v-row class="mx-2">
            <v-col class="pa-0 col-12">
              <v-row class="ma-0 mb-1">
                <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                  <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;">{{$t('__address')}}</div>
                </v-col>
                <v-col class="col-10 col-md-10" style="max-width: 83.33% !important; flex: 0 0 83.33% !important;">
                  <textarea class="pa-2 pt14" rows="2" :readonly="isReadOnly" :style="{'background-color': (isReadOnly) ? '#F4F8F9' : '#FFF'}" v-model="datasets.address"></textarea>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                  <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;">{{$t('__place')}}</div>
                </v-col>
                <v-col class="col-10 col-md-10" style="max-width: 83.33% !important; flex: 0 0 83.33% !important;">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.place" :readonly="isReadOnly" :background-color="isReadOnly?'#F4F8F9':'#FFF'" hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                  <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;">{{$t('__projectId')}}</div>
                </v-col>
                <v-col class="col-10 col-md-10" style="max-width: 83.33% !important; flex: 0 0 83.33% !important;">
                  <v-text-field class="text_field" dense background-color="white" outlined v-model="datasets.projectId" :readonly="isReadOnly" :background-color="isReadOnly?'#F4F8F9':'#FFF'" hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                  <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__issue')}}</div>
                </v-col>
                <v-col class="col-10 col-md-10" style="max-width: 83.33% !important; flex: 0 0 83.33% !important;">
                  <v-select class="text_field" dense background-color="white" outlined v-model="datasets.issue" 
                  :items="issueList" :item-text="(language == 'tw') ? 'CodeValue' : 'CodeText'" :item-value="item => String(item.id)" :readonly="isReadOnly" :background-color="isReadOnly?'#F4F8F9':'#FFF'" hide-details></v-select>
                </v-col>
              </v-row>
              <v-row class="ma-0 mb-1">
                <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                  <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;">{{$t('__remark')}}</div>
                </v-col>
                <v-col class="col-10 col-md-10" style="max-width: 83.33% !important; flex: 0 0 83.33% !important;">
                  <textarea class="pa-2 pt14" rows="2" :readonly="isReadOnly" :style="{'background-color': (isReadOnly) ? '#F4F8F9' : '#FFF'}" v-model="datasets.remark"></textarea>
                </v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                  <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;">{{$t('__picVideo')}}</div>
                </v-col>
                <v-col class="col-10 col-md-10" style="max-width: 83.33% !important; flex: 0 0 83.33% !important;">
                  <div class="pic-video-container d-flex align-center">
                    <div class="pic-video-box flex-grow-1 d-flex flex-wrap align-start justify-start">
                      <div v-for="(pv, idx) in picVideoPreviews" :key="idx" class="ma-2 pic-thumb-wrap" @click="openFileFullscreen({ url: pv.url, name: pv.fileName, isImage: pv.isImage })">
                        <v-img :src="pv.url" max-width="120" max-height="100" contain style="border-radius:4px;border:1px solid #eee;cursor:pointer;"></v-img>
                        <v-btn v-if="!isReadOnly" icon x-small color="#F44336" class="pic-thumb-del" @click.stop="removePicVideo(idx)">
                          <v-icon size="16">mdi-close-circle</v-icon>
                        </v-btn>
                      </div>
                      <div v-if="picVideoPreviews.length === 0" class="text-center grey--text py-6" style="width:100%;font-size:13px;">{{ $t('__noFilesSelected') }}</div>
                    </div>
                    <v-btn v-if="!isReadOnly" icon color="#00BCD4" class="ml-3 flex-shrink-0" @click="uploadPicVideo" :disabled="picVideoPreviews.length >= 3 || isUploadingPicVideo" :loading="isUploadingPicVideo">
                      <v-icon size="40">mdi-plus-circle</v-icon>
                    </v-btn>
                    <input ref="fileInput" type="file" multiple accept="image/*,video/*" style="display:none" @change="handlePicVideoUpload">
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </div>

      <!-- Assign Section -->
      <div id="box" class="pa-5 mt-5">
        <v-row class="pb-5 align-center" style="padding: 0px 2.5% 20px 2.5%">
          <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
          <h4 class="primary-color" style="padding-top:2px">{{ $t('__sectionAssign') }}</h4>
        </v-row>

        <v-row class="mx-2">
          <v-col class="pa-0 col-12">
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__assigned')}}</div>
              </v-col>
              <v-col class="col-10 col-md-10 d-flex align-center" style="max-width: 83.33% !important; flex: 0 0 83.33% !important;">
                <v-text-field class="text_field flex-grow-1 clickable-field" dense outlined :value="datasets.assigned" readonly :background-color="isReadOnly?'#F4F8F9':'#FFF'" hide-details @click="openEmployeeDialog('assigned')" style="cursor: pointer;"></v-text-field>
                <v-menu v-if="assignedContact" content-class="contact-tooltip" transition="fade-transition" z-index="1000" bottom open-on-hoveroffset-y:close-delay="200">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon dark class="ml-2 mt-n1" style="background-color: #EF6C00; border-radius: 8px" :disabled="isReadOnly" v-bind="attrs" v-on="on">
                      <v-icon>mdi-email-edit-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="pa-2 contact-tooltip-content" elevation="0">
                    <div class="tooltip-header mb-1">
                      <strong>{{ assignedContact.name }}</strong>
                    </div>
                    <v-divider class="mb-1"></v-divider>
                    <div  class="d-flex align-center mb-1 tooltip-item clickable-tooltip-item" :title="$t('__clickCopy')"
                    @click.stop="copyToClipboard(assignedContact.email)">
                      <v-icon small color="#555" class="mr-2">mdi-email-outline</v-icon>
                      <span class="selectable-text">{{ assignedContact.email || '-' }}</span>
                    </div>
                    <div class="d-flex align-center tooltip-item clickable-tooltip-item" :title="$t('__clickCopy')"
                    @click.stop="copyToClipboard(assignedContact.phone)">
                      <v-icon small color="#555" class="mr-2">mdi-phone</v-icon>
                      <span class="selectable-text">{{ assignedContact.phone || '-' }}</span>
                    </div>
                  </v-card>
                </v-menu>
                <v-btn v-else icon dark class="ml-2 mt-n1" style="background-color: #EF6C00; border-radius: 8px" :disabled="isReadOnly">
                  <v-icon>mdi-email-edit-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;">{{$t('__feFeedbackReport')}}</div>
              </v-col>
              <v-col class="col-10 col-md-10" style="max-width: 83.33% !important; flex: 0 0 83.33% !important;">
                <v-text-field class="text_field" dense outlined v-model="datasets.feFeedbackReport" :readonly="isReadOnly" :background-color="isReadOnly?'#F4F8F9':'#FFF'" hide-details></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;">{{$t('__suggestion')}}</div>
              </v-col>
              <v-col class="col-10 col-md-10" style="max-width: 83.33% !important; flex: 0 0 83.33% !important;">
                <v-text-field class="text_field clickable-field" dense outlined :value="suggestionDisplay" readonly :background-color="isReadOnly?'#F4F8F9':'#FFF'" hide-details @click="openEmployeeDialog('suggestion')" style="cursor: pointer;"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;">{{$t('__memberNotification')}}</div>
              </v-col>
              <v-col class="col-10 col-md-10 d-flex align-center" style="max-width: 83.33% !important; flex: 0 0 83.33% !important;">
                <v-text-field class="text_field flex-grow-1 clickable-field" dense outlined :value="memberNotificationDisplay" readonly :background-color="isReadOnly?'#F4F8F9':'#FFF'" hide-details @click="openEmployeeDialog('memberNotification')" style="cursor: pointer;"></v-text-field>
                <v-btn icon dark class="ml-2 mt-n1" style="background-color: #9E9E9E; border-radius: 8px" @click="addMemberNotification" :disabled="isReadOnly">
                  <v-icon size="34">mdi-information-slab-symbol</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-2" style="max-width: 16.66% !important; flex: 0 0 16.66% !important;">
                <div class="text-right pt-2 pt14" style="font-weight: 500; color: #666;">{{$t('__sales')}}</div>
              </v-col>
              <v-col class="col-10 col-md-10" style="max-width: 83.33% !important; flex: 0 0 83.33% !important;">
                <v-text-field class="text_field clickable-field" dense outlined :value="salesDisplay" readonly :background-color="isReadOnly?'#F4F8F9':'#FFF'" hide-details @click="openEmployeeDialog('sales')" style="cursor: pointer;"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <!-- History Section -->
      <div id="box" class="pa-5 mt-5">
        <v-row class="pb-5 align-center" style="padding: 0px 2.5% 20px 2.5%">
          <v-icon class="ma-0 pa-0 primary-color" size="28">mdi-menu-right</v-icon>
          <h4 class="primary-color" style="padding-top:2px">{{ $t('__sectionHistory') }}</h4>
        </v-row>

        <v-row class="mx-2">
          <v-col class="pa-0 col-12">
            <div id="listTable" class="ma-0">
              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr class="grey lighten-4">
                      <th class="text-center font-weight-bold" style="width: 80px">{{ $t('__no') }}</th>
                      <th class="text-center font-weight-bold" style="width: 150px">{{ $t('__date') }}</th>
                      <th class="text-center font-weight-bold">{{ $t('__issue') }}</th>
                      <th class="text-center font-weight-bold" style="width: 150px">{{ $t('__closeDate') }}</th>
                      <th class="text-center font-weight-bold">{{ $t('__feFeedbackReport') }}</th>
                      <th class="text-center font-weight-bold" style="width: 100px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(history, index) in historyList" :key="index">
                      <td class="text-center" style="min-width:70px">{{ index + 1 }}</td>
                      <td class="text-center" style="min-width:70px">{{ history.createTimeString ? history.createTimeString.split(' ')[0] : '' }}</td>
                      <td class="text-left py-2" style="min-width:200px">{{ history.issue }}</td>
                      <td class="text-center" style="min-width:70px">{{ history.closeDateString ? history.closeDateString.split(' ')[0] : '' }}</td>
                      <td class="text-left py-2" style="min-width:140px">{{ history.feFeedbackReport }}</td>
                      <td class="text-center" style="min-width:70px">
                        <v-btn icon dark class="ma-0 pa-0" style="background-color: #9E9E9E; border-radius: 8px" @click="history.id ? exportPdf(history.id, history.caseId, true) : null">
                          <div style="width: 24px; padding-top:2px">
                            <v-img :src="images.PDF" alt="PDF icon"></v-img>
                          </div>
                        </v-btn>
                      </td>
                    </tr>
                    <tr v-if="historyList.length === 0">
                      <td colspan="6" class="text-center grey--text py-10 font-italic">{{ $t('__noHistoryRecords') }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-col>
        </v-row>
      </div>

      <S3FileManager 
        folder="JobAssignment" 
        :sub-path="datasets.caseId || (datasets.id ? String(datasets.id) : 'empty-create')" 
        :section-title="$t('__s3Files')" 
        :read-only="isReadOnly || (!datasets.id && !datasets.caseId)" 
        :fixed-files="datasets.attachmentFiles"
        @files-updated="updateAttachmentFiles"
      />

    </div>
    
    <v-footer id="footer">
      <div class="text-center mx-auto footer">
        <v-btn class="btn" large color="#979491" style="color: #FFF; box-shadow:none" @click="redirectPath(backPath)">{{$t('__cancel')}}</v-btn>
        <v-btn v-if="!isReadOnly" class="btn" large color="#ED6D00" style="color: #FFF; box-shadow:none" @click="saveDataset()">{{$t('__confirm')}}</v-btn>
      </div>
    </v-footer>
    <ShowMsg ref="ShowMsg" :onSave="onSaveSuccess" />

    <!-- New Customer Dialog -->
    <v-dialog v-model="showNewCustomerDialog" min-width="500px" max-width="700px" persistent>
      <v-card class="dialog-padding">
        <v-card-title class="d-flex justify-space-between align-center pa-4">
          <span class="dialog-title">{{$t('__newCustomer')}}</span>
          <v-btn icon @click="showNewCustomerDialog = false">
            <v-icon size="30" color="#9E9E9E">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-form ref="newCustomerForm" lazy-validation>
            <div class="mb-1">
              <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__staffName')}}</div>
              <v-text-field v-model="newCustomerData.name" outlined dense hide-details placeholder="" :rules="[v => !!v || 'Name is required']"></v-text-field>
            </div>
            <div class="mb-1">
              <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;">{{$t('__contactPerson')}}</div>
              <v-text-field v-model="newCustomerData.contactPerson" outlined dense hide-details placeholder=""></v-text-field>
            </div>
            <div class="mb-1">
              <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;">{{$t('__phone')}}</div>
              <v-text-field v-model="newCustomerData.phoneNumber" outlined dense hide-details placeholder=""></v-text-field>
            </div>
            <div class="mb-1">
              <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;">{{$t('__address')}}</div>
              <v-text-field v-model="newCustomerData.address" outlined dense hide-details placeholder=""></v-text-field>
            </div>
            <div class="mb-1">
              <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;">{{$t('__email')}}</div>
              <v-text-field v-model="newCustomerData.emailAddress" outlined dense hide-details placeholder=""></v-text-field>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions class="justify-center pb-8">
          <v-btn class="colorBtn" outlined color="#FFF" @click="showNewCustomerDialog = false">{{$t('__cancel')}}</v-btn>
          <v-btn class="colorBtn primary-color-background" outlined color="#FFF" @click="saveNewCustomer">{{$t('__confirm')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Status Track Dialog -->
    <v-dialog v-model="showStatusTrackDialog" min-width="500px" max-width="700px" persistent>
      <v-card class="dialog-padding">
        <v-card-title class="d-flex justify-space-between align-center pa-4">
          <span class="styleH3">{{(displayMode === 0) ? $t('__caseId'): ''}} {{datasets.caseId}}</span>
          <v-btn icon @click="showStatusTrackDialog = false">
            <v-icon size="30" color="#9E9E9E">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <div class="mb-3">
            <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__createTime')}}</div>
            <v-text-field v-model="statusTrackData.createTime" outlined dense hide-details readonly background-color="#F4F8F9"></v-text-field>
          </div>

          <div class="mb-3">
            <div class="mb-1 text-left pt14" style="font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__status')}}</div>
            <v-select v-model="statusTrackData.status" :items="trackStatusList" outlined dense hide-details></v-select>
          </div>

          <div class="mb-3">
            <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__feFeedbackReport')}}</div>
            <textarea class="pa-2 pt14" rows="3" v-model="statusTrackData.feFeedbackReport"></textarea>
          </div>

          <div class="mb-3">
            <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__files')}}</div>
            <div class="status-track-preview-box border rounded pa-2 d-flex flex-wrap justify-start" style="min-height: 100px; background-color: #fff;">
              <div v-for="(preview, idx) in statusTrackPreviews" :key="idx" class="ma-1 pic-thumb-wrap" @click="openFileFullscreen(preview)">
                <template v-if="preview.isImage">
                  <v-img :src="preview.url" max-width="100" max-height="100" contain class="border rounded" style="cursor:pointer;"></v-img>
                </template>
                <template v-else>
                  <div class="d-flex flex-column align-center justify-center border rounded" style="width:90px;height:80px;background:#f9f9f9;cursor:pointer;">
                    <v-icon color="#ED6D00" size="28">mdi-file-outline</v-icon>
                    <div style="font-size:9px;color:#666;margin-top:4px;text-align:center;word-break:break-all;padding:0 4px;">{{ filterGuidName(preview.fileName) }}</div>
                  </div>
                </template>
                <v-btn icon x-small color="#F44336" class="pic-thumb-del" @click.stop="removeStatusTrackFile(idx)">
                  <v-icon size="16">mdi-close-circle</v-icon>
                </v-btn>
              </div>
              <div v-if="statusTrackPreviews.length === 0" class="d-flex align-center" style="width:100%;color:#bbb;font-size:13px;font-style:italic;min-height:80px;padding-left:8px;">{{ $t('__noFilesSelected') }}</div>
            </div>
          </div>

          <div class="status-track-file-input-row d-flex align-center mb-4 submenu" @click="triggerStatusTrackUpload" :loading="isUploadingTrackFile" :disabled="isUploadingTrackFile">
            <div class="status-track-file-placeholder flex-grow-1 border rounded pa-2">
              {{ (displayMode === 0) ? $t('__selectFilesPlaceholder') : $t('__selectFilesPlaceholder2') }}
            </div>
            <v-btn small color="#9E9E9E" dark class="file-input2 colorBtn primary-color-background ma-0" style="height: 40px !important;">
              {{$t('__chooseFile')}}
            </v-btn>
          </div>
        </v-card-text>

        <v-card-actions class="justify-center pb-6 px-4">
          <v-btn class="colorBtn primary-color-background" outlined color="#FFF" style="width:100%" @click="saveStatusTrack">{{$t('__confirm')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Employee Selection Dialog -->
    <v-dialog v-model="showEmployeeDialog" min-width="500px" max-width="700px" persistent>
      <v-card class="dialog-padding">
        <v-card-title class="d-flex justify-space-between align-center pa-4">
          <span class="dialog-title">
            {{ 
              employeeDialogMode === 'assigned' ? $t('__assigned') : 
              employeeDialogMode === 'suggestion' ? $t('__suggestion') : 
              employeeDialogMode === 'sales' ? $t('__sales') :
              $t('__memberNotification') 
            }}
          </span>
          <v-btn icon @click="showEmployeeDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-4 pb-0 keyword-bar">
          <!-- Search -->
          <v-text-field outlined :placeholder="$t('__keywordSearch')" class="mt-1 mb-2 keyword text_field"
          dense v-model="employeeSearchKeyword" background-color="white">
            <template v-slot:append>
              <v-icon color="white" style="background:#ED6D00">
              icon-form_search
              </v-icon>
            </template>
          </v-text-field>

          <!-- Employee List -->
            <div id="listTable" style="margin:0; padding:0">
              <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width: 40px;" class="text-center"></th>
                    <th class="text-left">{{$t('__staffName')}}</th>
                    <th class="text-left">{{$t('__empId')}}</th>
                    <th class="text-left">{{$t('__title')}}</th>
                    <th class="text-left">{{$t('__account')}}</th>
                    <th class="text-left">{{$t('__phone')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="emp in filteredEmployeeList" :key="emp.employeeId || emp.id" @click="toggleEmployee(emp.name)" style="cursor: pointer;" :class="{ 'emp-selected-row': isEmployeeSelected(emp.name) }">
                    <td class="text-center">
                      <v-icon v-if="isEmployeeSelected(emp.name)" color="#ED6D00" size="20">mdi-checkbox-marked</v-icon>
                      <v-icon v-else color="#999" size="20">mdi-checkbox-blank-outline</v-icon>
                    </td>
                    <td class="text-left" style="min-width:140px">{{ emp.name }}</td>
                    <td class="text-left" style="min-width:120px">{{ emp.employeeId }}</td>
                    <td class="text-left" style="min-width:90px">{{ emp.title }}</td>
                    <td class="text-left" style="min-width:90px">{{ emp.account }}</td>
                    <td class="text-left" style="min-width:90px">{{ emp.phone }}</td>
                  </tr>
                  <tr v-if="filteredEmployeeList.length === 0">
                    <td colspan="6" class="text-center grey--text py-4">{{ $t('__noEmployeesFound') }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <!-- Selected summary -->
          <div class="mt-3 text-body-2 d-flex flex-wrap align-center" style="color: #666; gap: 8px;">
            <span>{{ $t('__selected') }}:</span>
            <template v-if="employeeDialogSelected.length > 0">
              <v-chip v-for="(name, idx) in employeeDialogSelected" :key="idx"
                class="ma-1" small close outlined color="#ED6D00"
                @click:close="removeSelectedEmployee(name)">
                {{ name }}
              </v-chip>
            </template>
            <span v-else><strong>{{ $t('__none') }}</strong></span>
          </div>
        </v-card-text>

        <v-card-actions class="justify-center pb-4 px-4 mt-2">
          <v-btn class="colorBtn" outlined color="#FFF" @click="showEmployeeDialog = false">{{$t('__cancel')}}</v-btn>
          <v-btn class="colorBtn primary-color-background" outlined color="#FFF" @click="confirmEmployeeSelection">{{$t('__confirm')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Status Track File Input (outside dialog to avoid ref timing issues) -->
    <input ref="statusTrackFileInput" type="file" multiple accept="image/*,video/*" style="display:none" @change="handleStatusTrackFileUpload">

    <!-- Step Preview Dialog -->
    <v-dialog v-model="showStepPreviewDialog" min-width="500px" max-width="700px" persistent>
      <v-card class="dialog-padding">
        <v-card-title class="d-flex justify-space-between align-center pa-4">
          <span class="styleH3">{{(displayMode === 0) ? $t('__caseId'): ''}} {{datasets.caseId}}</span>
          <v-btn icon @click="showStepPreviewDialog = false">
            <v-icon size="30" color="#9E9E9E">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <!-- Create Time -->
          <div class="mb-3">
            <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__createTime')}}</div>
            <v-text-field :value="stepPreviewData.date + ' ' + stepPreviewData.time" outlined dense hide-details readonly background-color="#F4F8F9"></v-text-field>
          </div>

          <!-- Status + Color swatch -->
          <div class="mb-3">
            <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__status')}}</div>
            <div class="d-flex align-center" style="gap: 10px;">
              <v-text-field :value="stepPreviewData.label" outlined dense hide-details readonly background-color="#F4F8F9" class="flex-grow-1"></v-text-field>
              <div :style="{ width: '36px', height: '36px', borderRadius: '50%', backgroundColor: stepPreviewData.color || '#9E9E9E', flexShrink: 0, border: '2px solid rgba(0,0,0,0.08)', boxShadow: '0 2px 6px rgba(0,0,0,0.2)' }"></div>
            </div>
          </div>

          <!-- Operator -->
          <div class="mb-3">
            <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__staffName')}}</div>
            <v-text-field :value="stepPreviewData.name" outlined dense hide-details readonly background-color="#F4F8F9"></v-text-field>
          </div>

          <!-- Feedback -->
          <div class="mb-3">
            <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__feFeedbackReport')}}</div>
            <textarea class="pa-2 pt14" rows="3" readonly v-model="stepPreviewData.feedback"></textarea>
          </div>

          <!-- Attachments -->
          <div class="mb-3">
            <div class="mb-1 text-left" style="font-size: 14px; font-weight: 500; color: #666;"><span class="start">*</span>{{$t('__files')}}</div>
            <div v-if="isLoadingStepFiles" class="status-track-preview-box border rounded pa-2 d-flex align-center justify-center" style="min-height: 100px;">
              <v-progress-circular indeterminate color="#ED6D00" size="32"></v-progress-circular>
            </div>
            <div v-else class="status-track-preview-box border rounded pa-2 d-flex flex-wrap" style="min-height: 100px; background-color: #fff;">
              <div v-for="(item, idx) in stepPreviewFileUrls" :key="idx"
                class="ma-1 step-preview-thumb" @click="openFileFullscreen(item)">
                <v-img v-if="item.isImage" :src="item.url"
                  class="border rounded" max-width="100" max-height="100" contain style="cursor: pointer;"
                ></v-img>
                <div v-else
                  class="d-flex flex-column align-center justify-center border rounded"
                  style="width: 90px; height: 80px; background: #f9f9f9; cursor: pointer;"
                >
                  <v-icon color="#ED6D00" size="28">mdi-file-outline</v-icon>
                  <div style="font-size: 10px; color: #666; margin-top: 4px; text-align: center; word-break: break-all; padding: 0 4px;">{{ filterGuidName(item.name) }}</div>
                </div>
              </div>
              <div v-if="stepPreviewFileUrls.length === 0" class="d-flex align-center justify-center" style="width: 100%; color: #bbb; font-size: 13px; font-style: italic; min-height: 80px;">{{ $t('__noAttachments') }}</div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Fullscreen Image Preview -->
    <v-dialog v-model="showFullscreenDialog" min-width="500px" max-width="700px">
      <v-card style="background: #000; border-radius: 8px; position: relative;">
        <v-btn icon dark style="position: absolute; top: 8px; right: 8px; z-index: 10;" @click="showFullscreenDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-img v-if="fullscreenItem && fullscreenItem.isImage" :src="fullscreenItem.url" contain max-height="85vh" style="border-radius: 8px;"></v-img>
        <div v-else class="pa-8 text-center">
          <v-icon color="white" size="60">mdi-file-outline</v-icon>
          <div style="color: white; margin-top: 12px;">{{ fullscreenItem && filterGuidName(fullscreenItem.name || fullscreenItem.fileName) }}</div>
          <v-btn class="mt-4" color="#ED6D00" dark :href="fullscreenItem && fullscreenItem.url" target="_blank">{{ $t('__download') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <ShowMsg ref="ShowMsg" :onSave="onSaveSuccess" />
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ShowMsg from '@/dialogs/ShowMsg'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import S3FileManager from '@/components/S3FileManager'
import { getEmployeeInfo, getRoles, getEmployeeName } from '@/utils/auth'

export default {
  name: 'JobAssignment',
  components: {ShowMsg, Loading, S3FileManager},
  data: () => ({
    displayMode:'',
    isLoading: false,
    valid: true,
    viewStyle: {},
    addNewData:0, //0-新增 1-修改
    datasets: {
      id: '',
      customer: '',
      groupName: '',
      item: '',
      itemId: '',
      serialNumber: '',
      address: '',
      place: '',
      projectId: '',
      issue: '',
      remark: '',
      attachmentGuids: [],
      attachmentFiles: [],
      assigned: '',
      memberNotification: [],
      sales: [],
      feFeedbackReport: '',
      suggestion: '',
      caseId: '',
      creatorId: '',
      creatorName: '',
      createTimeString: '',
      editorId: '',
      editorName: '',
      updateTimeString: '',
      statusHistory: ''
    },
    // Lists for dropdowns
    customerList: [],
    deviceList: [],
    groupList: [],
    issueList: [],
    assignedList: [],

    // Status Track Steps (built from API statusHistory)
    statusSteps: [],
    // Status
    currentStep: 1,
    // Attachments
    attachmentPreviews: [],
    // History
    historyList: [],
    // Other
    language: '',
    isReadOnly: false,
    isClosedJob: false,
    backPath: '/jobAssignmentList',
    // New Customer Dialog
    showNewCustomerDialog: false,
    newCustomerData: {
      name: '',
      contactPerson: '',
      phoneNumber: '',
      address: '',
      emailAddress: ''
    },
    // Status Track
    showStatusTrackDialog: false,
    statusTrackData: {
      createTime: '',
      status: '',
      feFeedbackReport: '',
      files: []
    },
    statusTrackPreviews: [],
    trackStatusList: [],
    // Pic/Video (S3 PicVideo subfolder)
    picVideoPreviews: [], // [{ url, fileName, key }]
    isUploadingPicVideo: false,
    // Upload states
    isUploadingTrackFile: false,
    // Employee Selection Dialog
    showEmployeeDialog: false,
    employeeDialogMode: '', // 'assigned', 'suggestion', 'memberNotification'
    employeeDialogMultiple: false,
    employeeList: [],
    employeeSearchKeyword: '',
    employeeDialogSelected: [],
    // Step Preview Dialog
    showStepPreviewDialog: false,
    stepPreviewData: {},
    stepPreviewFileUrls: [],
    isLoadingStepFiles: false,
    showFullscreenDialog: false,
    fullscreenItem: null,
    warrantyStatus: null,
    
    images:{
      PDF: require('@/assets/image/PDF.png'),
    },
  }),
  mounted() {
    this.language = i18n.locale
    this.addNewData = (this.$route.query.id == -1) ? 0 : 1
    this.initializeLists()
    this.checkMode()
  },
  created() {
    this.calculateWindows()
    this.$root.$on('windowInnerHeight', () => {
      this.calculateWindows()
    })
    this.$root.$on('language', (value) => {
      this.language = value
    })
  },
  computed: {
    canEditJob() {
      try {
        const info = getEmployeeInfo()
        if (info && info.function) {
          const perms = JSON.parse(info.function)
          const p = perms.find(e => e.key === 'JobAssignment')
          return p ? !!p.edit : false
        }
      } catch (e) {
        console.error('Failed to parse permissions:', e)
      }
      return false
    },
    isManager() {
      return getRoles().isManager
    },
    isAssigned() {
      return this.datasets.assigned === getEmployeeName()
    },
    filteredEmployeeList() {
      let list = this.employeeList

      // 如果是業務模式，先篩選具備 Sales 角色的人員
      if (this.employeeDialogMode === 'sales') {
        list = list.filter(emp => {
          const roleStr = emp.role || emp.roles || ''
          const roles = roleStr.split(',').map(r => r.trim())
          return roles.includes('Sales')
        })
      }

      if (!this.employeeSearchKeyword) return list
      var kw = this.employeeSearchKeyword.toLowerCase()
      return list.filter(function(emp) {
        return (emp.name && emp.name.toLowerCase().includes(kw)) ||
               (emp.employeeId && emp.employeeId.toLowerCase().includes(kw)) ||
               (emp.title && emp.title.toLowerCase().includes(kw)) ||
               (emp.account && emp.account.toLowerCase().includes(kw)) ||
               (emp.phone && emp.phone.toLowerCase().includes(kw))
      })
    },
    suggestionDisplay() {
      var val = this.datasets.suggestion
      if (Array.isArray(val)) return val.join('; ')
      return val || ''
    },
    memberNotificationDisplay() {
      var val = this.datasets.memberNotification
      if (Array.isArray(val)) return val.join('; ')
      return val || ''
    },
    salesDisplay() {
      var val = this.datasets.sales
      if (Array.isArray(val)) return val.join('; ')
      return val || ''
    },
    assignedContact() {
      if (!this.datasets.assigned || !this.employeeList.length) return null
      const emp = this.employeeList.find(e => e.name === this.datasets.assigned)
      if (!emp) return null
      return {
        name: emp.name,
        email: emp.account || emp.email || emp.mail || '',
        phone: emp.phone || emp.mobile || ''
      }
    },
    warrantyStatusClass() {
      if (!this.warrantyStatus) return ''
      const status = (this.warrantyStatus.Status || this.warrantyStatus.status || '').toLowerCase()
      if (status === 'active') return 'active'
      if (status === 'expired') return 'expired'
      if (status === 'upcoming') return 'upcoming'
      return ''
    },
    displayWarrantyStatus() {
      if (!this.warrantyStatus) return ''
      return this.warrantyStatus.Status || this.warrantyStatus.status || ''
    },
    warrantyDateRange() {
      if (!this.warrantyStatus) return ''
      const start = this.warrantyStatus.StartDate || this.warrantyStatus.startDate
      const end = this.warrantyStatus.EndDate || this.warrantyStatus.endDate
      if (!start || !end) return ''
      return `${start} - ${end}`
    }
  },
  watch: {
    'datasets.customer': function(newVal) {
      if (newVal) {
        this.fetchCustomerHistory(newVal)
      } else {
        this.historyList = []
      }
    }
  },
  methods: {
    calculateWindows() {
      this.viewStyle = {height: window.innerHeight - 135 + 'px'}
      if(window.innerWidth >= 960){
        this.displayMode = 0
      } else {
        this.displayMode = 1
      }
    },
    redirectPath(path) {
      this.$router.push({ path: path, query: { page: this.$route.query.page } })
    },
    onSaveSuccess() {
      this.redirectPath('/jobAssignmentList')
    },
    checkMode() {
      if (sessionStorage.getItem('isClosedJob') === 'true') {
         this.isReadOnly = true
         this.isClosedJob = true
         this.backPath = '/historyRecordList'
      }
      
      if (!this.canEditJob) {
        this.isReadOnly = true
      }

      if (this.addNewData === 1) {
        this.getDataset(this.$route.query.id)
      } else {
        // Fetch pre-allocated ID for new record
        var self = this
        this.$http.get('/JobAssignment/PreallocateJobAssignmentId').then(response => {
          const newId = response.data.Data || response.data.data || response.data || ''
          if (newId) {
            self.datasets.caseId = newId
            self.datasets.projectId = newId
          }
        }).catch(err => {
          console.error('Failed to pre-allocate JobAssignment ID:', err)
        })

        // 為新紀錄初始化預設值 — 預先填充狀態歷史為 "New"
        var empName = sessionStorage.getItem('manageMemberName') || ''
        var empId = sessionStorage.getItem('manageMemberSysId') || ''
        var defaultHistory = [{
          status: 'New',
          employeeId: empId,
          employeeName: empName,
          color: '#C1BDBB',
          feedback: 'Issue reported by user. Initial status recorded.',
          files: [],
          timestamp: new Date().toISOString()
        }]
        this.datasets.statusHistory = JSON.stringify(defaultHistory)
        this.buildStatusSteps()
      }
    },
    deepParse(val) {
      if (val === null || val === undefined) return []
      if (typeof val === 'string') {
        var trimmed = val.trim()
        if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) return val
        try {
          const parsed = JSON.parse(val)
          return this.deepParse(parsed)
        } catch (e) {
          return val
        }
      }
      if (Array.isArray(val)) {
        var result = []
        val.forEach(item => {
          const parsed = this.deepParse(item)
          if (Array.isArray(parsed)) {
            result = result.concat(parsed)
          } else {
            result.push(parsed)
          }
        })
        return result
      }
      return val
    },
    getDataset(id) {
      this.isLoading = true
      var self = this
      var url = this.isClosedJob ? '/GetClosedJobAssignment' : '/GetJobAssignment'
      var request = {
        method: 'GET',
        url: url,
        params: { id: id, lang: this.language || 'en-US' },
      }
      this.$http(request).then(function(response) {
        if (response.data.Data) {
            self.datasets = response.data.Data
        } else if (response.data.data) {
             self.datasets = response.data.data
        } else {
             self.datasets = response.data
        }
        
        // Ensure ID is populated (History records might return a record ID or jobId instead of 'id')
        if (!self.datasets.id && self.$route.query.id) {
          self.datasets.id = self.$route.query.id
        }

        if (self.datasets.attachmentFiles) {
          self.datasets.attachmentFiles = self.deepParse(self.datasets.attachmentFiles)
        } else {
          self.datasets.attachmentFiles = []
        }

        if (self.datasets.attachmentGuids) {
          self.datasets.attachmentGuids = self.deepParse(self.datasets.attachmentGuids)
        } else {
          self.datasets.attachmentGuids = []
        }

        self.buildStatusSteps()
        self.loadPicVideoPreviews()
        if (self.datasets.serialNumber) {
          self.checkWarrantyStatus(self.datasets.serialNumber)
        }
      }).catch((err) => {
        const errorMsg = err.response?.data?.Message || err.response?.data?.ErrorMessage || self.$t('__getDataError')
        self.$refs.ShowMsg.open(0, self.$t('__error'), errorMsg, true, true)
      }).finally(() => {
        self.isLoading = false
      })
    },
    onSaveSuccess() {
      if (this.$route.path !== '/jobAssignmentList') {
        this.redirectPath('/jobAssignmentList')
      }
    },

    saveDataset() {
      if (!this.$refs.form.validate()) return

      // Manual required field check
      if (!this.datasets.customer || !this.datasets.item || !this.datasets.itemId || !this.datasets.serialNumber || !this.datasets.issue || !this.datasets.caseId || !this.datasets.assigned) {
        this.$refs.ShowMsg.open(1)
        return
      }

      this.isLoading = true
      var self = this
      // Format data based on mode (create vs update)
      var url = this.datasets.id ? '/UpdateJobAssignment' : '/CreateJobAssignment'
      var method = 'POST'
      
      // Prepare data for API - exclude system fields when creating
      var requestData = Object.assign({}, this.datasets)
      
      if (!this.datasets.id) {
        // For create, only send API required fields or filter out internal ones if needed
        // but consistently it's better to exclude some or just send all that are relevant
        requestData = {
          caseId: this.datasets.caseId,
          customer: this.datasets.customer,
          groupName: this.datasets.groupName,
          item: this.datasets.item,
          itemId: this.datasets.itemId,
          serialNumber: this.datasets.serialNumber,
          address: this.datasets.address,
          place: this.datasets.place,
          projectId: this.datasets.projectId,
          issue: this.datasets.issue,
          remark: this.datasets.remark,
          attachmentGuids: JSON.stringify(this.datasets.attachmentGuids || []),
          attachmentFiles: JSON.stringify(this.datasets.attachmentFiles || []),
          assigned: this.datasets.assigned,
          feFeedbackReport: this.datasets.feFeedbackReport || '',
          suggestion: this.datasets.suggestion || '',
          memberNotification: this.datasets.memberNotification || [],
          sales: this.datasets.sales || [],
          statusHistory: this.datasets.statusHistory || ''
        }
      } else {
        // Stringify attachments for Update mode
        requestData.attachmentFiles = JSON.stringify(this.datasets.attachmentFiles || [])
        requestData.attachmentGuids = JSON.stringify(this.datasets.attachmentGuids || [])
      }
      
      // Set status from the last entry in statusHistory
      try {
        var historyStr = requestData.statusHistory || this.datasets.statusHistory || ''
        var historyArr = typeof historyStr === 'string' ? JSON.parse(historyStr) : historyStr
        if (Array.isArray(historyArr) && historyArr.length > 0) {
          requestData.status = historyArr[historyArr.length - 1].status || ''
        }
      } catch (e) {
        console.error('Failed to parse statusHistory for status:', e)
      }

      var request = {
        method: method,
        url: url,
        headers: {
          'Content-Type': 'application/json-patch+json'
        },
        data: requestData
      }
      this.$http(request).then(function(response) {
        self.$refs.ShowMsg.open(0, i18n.t('__savedSuccessfully'), response.data.Message, true) // Success with callback
      }).catch((error) => {
        console.error('Save error:', error)
        var errorMsg = error.response?.data?.Message || this.$t('__saveFailed')
        self.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
      }).finally(() => {
        self.isLoading = false
      })
    },
    updateAttachmentFiles(files) {
      this.datasets.attachmentFiles = files
    },
    initializeLists() {
      // Initialize dropdown lists - these would normally come from API
      var self = this
      
      // Fetch Customers
      this.$http.get('/GetCustomerList').then(response => {
        const data = response.data.Data || response.data.data || response.data || []
        self.customerList = data.map(item => item.name)
      })

      this.getDeviceList()
      this.getIssueList()

      // Fetch Groups from Organization list
      this.$http.get('/GetOrganizationList', { params: { currentPage: 1, pageSize: 9999 } }).then(response => {
        const data = response.data.Data || response.data.data || response.data || []
        if (Array.isArray(data)) {
          self.groupList = data.map(item => item.groupName).filter(Boolean)
        }
      })

      // Fetch Employee list from API
      this.$http.get('/EmployeeList', { 
        params: { 
          currentPage: 1, 
          pageSize: 9999,
          orderBy: 'name',
          isNamePriority: true,
          direction: 'asc'
        } 
      }).then(response => {
        var data = response.data.Data || response.data.data || response.data || []
        if (Array.isArray(data)) {
          self.employeeList = data
        }
      })

      // Fetch Track Status list from API
      this.$http.get('/CodeTypeList', { params: { CodeType: 'TrackStatus', currentPage: 1, pageSize: 9999 } }).then(response => {
        var data = response.data.Data || response.data.data || response.data || []
        if (Array.isArray(data)) {
          self.trackStatusList = data.map(item => ({
            text: item.CodeText,
            value: item.CodeText,
            color: item.CodeValue || '#9E9E9E'
          }))
        }
      })
    },
    getDeviceList(){
      var self = this
      var request = {
        method: 'GET',
        url: '/GetDeviceList',
        params: {
          'orderBy': self.orderBy,
          'direction': self.direction,
          'pageSize': 99999,
          'currentPage': 1 ,
          'limit': 9999,
          'keyword': null,
          'customer': null,
          'status': null,
        },
      }
      this.$http(request).then(function(response) {
        self.deviceList = response.data.Data || []
      }).catch(()=>{
        alert(this.$t('__systemError', { code: 'Job-7971' }))
      }).finally(()=>{
      })
    },
    getIssueList(){
      var self = this
      var request = {
        method: 'GET',
        url: '/CodeTypeList',
        params: {
          CodeType: 'MaintenanceReason',
          pagesize: 9999,
          currentPage: 1,
        },
      }
      this.$http(request).then(function(response) {
        self.issueList = response.data.Data || []
      }).catch(()=>{
        alert(this.$t('__systemError', { code: 'Job-7972' }))
      }).finally(()=>{
      })
    },

    // ── Pic/Video (S3 PicVideo subfolder) ─────────────────────────────────────
    loadPicVideoPreviews() {
      var self = this
      var guids = self.deepParse(this.datasets.attachmentGuids)
      if (!Array.isArray(guids) || guids.length === 0) return
      self.picVideoPreviews = []
      guids.forEach(function(item) {
        if (!item) return
        // item may be a full key string (legacy) or an object {fileName, filePath}
        // Ensure we extract the actual file path and fileName correctly
        var storedKey = ''
        var originalFileName = ''
        if (typeof item === 'object' && item !== null) {
          storedKey = item.filePath || ''
          originalFileName = item.fileName || ''
        } else {
          storedKey = String(item)
          originalFileName = storedKey.includes('/') ? storedKey.split('/').pop() : storedKey
        }
        if (!storedKey) return
        
        // Clean up any potential JSON artifacts from legacy or double-encoded data
        if (typeof storedKey === 'string' && (storedKey.includes('"') || storedKey.includes('}') || storedKey.includes(']'))) {
           try {
             var attempt = self.deepParse(storedKey)
             if (typeof attempt === 'object' && attempt !== null && !Array.isArray(attempt)) {
               storedKey = attempt.filePath || storedKey
               if (attempt.fileName) originalFileName = attempt.fileName
             } else if (Array.isArray(attempt) && attempt.length > 0) {
               var first = attempt[0]
               storedKey = (typeof first === 'object' && first !== null) ? (first.filePath || '') : String(first)
               if (typeof first === 'object' && first !== null && first.fileName) originalFileName = first.fileName
             }
           } catch(e) {}
           // Final fallback: strip trailing artifacts if they still exist
           storedKey = String(storedKey).replace(/["}\]]+$/, '')
           originalFileName = String(originalFileName).replace(/["}\]]+$/, '')
        }

        var isFullKey = storedKey.includes('/') && !storedKey.startsWith('{') && !storedKey.startsWith('[')
        var params = isFullKey
          ? { fileName: storedKey.split('/').pop(), subFolder: storedKey.split('/').slice(1, -1).join('/') }
          : { fileName: storedKey, subFolder: 'PicVideo' }
        self.$http.get('/S3/JobAssignment/Get', { params: params }).then(function(response) {
          var data = response.data?.Data || response.data?.data || response.data || {}
          var url = data.preSignedUrl || data.PreSignedUrl || data.publicUrl || ''
          // Always prefer the full key returned by API; fallback to constructing it
          var fullKey = data.key || data.Key || (isFullKey ? storedKey : ('JobAssignment/PicVideo/' + storedKey))
          var ext = (fullKey || '').split('.').pop().toLowerCase()
          var isImage = ['jpg','jpeg','png', 'gif', 'bmp', 'webp', 'svg'].includes(ext)
          if (url) self.picVideoPreviews.push({ url: url, fileName: originalFileName, key: fullKey, isImage: isImage })
        }).catch(function() {})
      })
    },
    uploadPicVideo() { this.$refs.fileInput.click() },
    handlePicVideoUpload(event) {
      const allFiles = Array.from(event.target.files) // capture as static array BEFORE clearing
      event.target.value = ''
      if (!allFiles.length) return
      const remaining = 3 - this.picVideoPreviews.length
      if (remaining <= 0) {
        this.$refs.ShowMsg.open(0, this.$t('__requiredTitle'), 'Maximum 3 files allowed')
        return
      }
      const filesToProcess = allFiles.slice(0, remaining)
      this.isUploadingPicVideo = true
      var self = this
      var uploads = filesToProcess.map(function(file) {
        var formData = new FormData()
        formData.append('file', file)
        var idFolder = self.datasets.caseId || self.datasets.id || 'Temp'
        return self.$http.post(`/S3/JobAssignment/Upload?subFolder=${idFolder}/PicVideo`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(function(response) {
          var data = response.data?.Data || response.data?.data || response.data || {}
          var fileName = data.fileName || data.FileName || file.name
          var idFolder = self.datasets.caseId || self.datasets.id || 'Temp'
          var fullKey = data.key || data.Key || (`JobAssignment/${idFolder}/PicVideo/${fileName}`)
          var url = data.preSignedUrl || data.PreSignedUrl || data.publicUrl || ''
          if (!Array.isArray(self.datasets.attachmentGuids)) self.datasets.attachmentGuids = []
          // Store object {fileName, filePath} in attachmentGuids for consistency with attachmentFiles
          self.datasets.attachmentGuids.push({
            fileName: file.name,
            filePath: fullKey
          })
          // Show preview immediately
          if (url) {
            self.picVideoPreviews.push({ url: url, fileName: file.name, key: fullKey, isImage: file.type.startsWith('image/') })
          } else if (file.type.startsWith('image/')) {
            // Fallback local preview
            var reader = new FileReader()
            reader.onload = function(e) { self.picVideoPreviews.push({ url: e.target.result, fileName: file.name, key: fullKey }) }
            reader.readAsDataURL(file)
          }
        })
      })
      Promise.allSettled(uploads).then(function(results) {
        if (results.some(function(r) { return r.status === 'rejected' })) {
          self.$refs.ShowMsg.open(0, this.$t('__uploadFailed'), this.$t('__uploadFailedPartially'))
        }
        self.isUploadingPicVideo = false
      })
    },
    removePicVideo(idx) {
      var pv = this.picVideoPreviews[idx]
      if (!pv) return
      // pv.key should always be the full S3 key (e.g. JobAssignment/PicVideo/xxx.png)
      // Fallback: construct full key if somehow only filename is stored
      var s3Key = pv.key || ('JobAssignment/PicVideo/' + (pv.fileName || ''))
      if (s3Key) {
        this.$http.post('/S3/JobAssignment/Delete', null, { params: { key: s3Key } }).catch(function() {})
      }
      // Remove from local state
      this.picVideoPreviews.splice(idx, 1)
      if (Array.isArray(this.datasets.attachmentGuids)) {
        // Handle both object format and legacy string format
        var gIdx = this.datasets.attachmentGuids.findIndex(function(item) {
          if (typeof item === 'string') {
            return item === pv.fileName || item === s3Key
          } else {
            return item.filePath === s3Key
          }
        })
        if (gIdx >= 0) this.datasets.attachmentGuids.splice(gIdx, 1)
      }
    },
    // ── Legacy stubs (kept to avoid reference errors) ──────────────────────────
    uploadAttachment() { this.uploadPicVideo() },
    handleFileUpload(event) { this.handlePicVideoUpload(event) },

    addCustomer() {
      this.newCustomerData = {
        name: '',
        contactPerson: '',
        phoneNumber: '',
        address: '',
        emailAddress: ''
      }
      this.showNewCustomerDialog = true
      if (this.$refs.newCustomerForm) {
        this.$refs.newCustomerForm.resetValidation()
      }
    },
    saveNewCustomer() {
      if (!this.$refs.newCustomerForm.validate()) return
      
      this.isLoading = true
      var self = this
      var request = {
        method: 'POST',
        url: '/CreateCustomer',
        headers: {
          'Content-Type': 'application/json-patch+json'
        },
        data: this.newCustomerData
      }
      
      this.$http(request).then(function(response) {
        self.showNewCustomerDialog = false
        self.$refs.ShowMsg.open(0, i18n.t('__savedSuccessfully'), i18n.t('__savedSuccessfully'))
        
        // Refresh customer list and auto-select the new one
        const newCustomerName = self.newCustomerData.name
        self.$http.get('/GetCustomerList').then(res => {
          const data = res.data.Data || res.data.data || res.data || []
          self.customerList = data.map(item => item.name)
          self.datasets.customer = newCustomerName
        })
      }).catch((error) => {
        const errorMsg = error.response?.data?.Message || this.$t('__saveFailed')
        self.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
      }).finally(() => {
        self.isLoading = false
      })
    },
    addMemberNotification() {
      // Open notice dialog using ShowMsg component
      this.$refs.ShowMsg.open(0, this.$t('__noticeTitle'), this.$t('__noticeContent'))
    },
    // Employee Selection Dialog
    openEmployeeDialog(mode) {
      if (this.isReadOnly) return
      this.employeeDialogMode = mode
      this.employeeDialogMultiple = (mode !== 'assigned')
      this.employeeSearchKeyword = ''
      this.employeeDialogSelected = []
      
      if (mode === 'assigned') {
        if (this.datasets.assigned) this.employeeDialogSelected = [this.datasets.assigned]
      } else if (mode === 'suggestion') {
        if (typeof this.datasets.suggestion === 'string' && this.datasets.suggestion) {
          this.employeeDialogSelected = this.datasets.suggestion.split('; ').filter(Boolean)
        }
      } else if (mode === 'memberNotification') {
        if (Array.isArray(this.datasets.memberNotification)) {
          this.employeeDialogSelected = [...this.datasets.memberNotification]
        }
      } else if (mode === 'sales') {
        if (Array.isArray(this.datasets.sales)) {
          this.employeeDialogSelected = [...this.datasets.sales]
        }
      }
      this.showEmployeeDialog = true
    },
    isEmployeeSelected(empName) {
      return this.employeeDialogSelected.includes(empName)
    },
    toggleEmployee(empName) {
      if (this.employeeDialogMultiple) {
        var idx = this.employeeDialogSelected.indexOf(empName)
        if (idx >= 0) {
          this.employeeDialogSelected.splice(idx, 1)
        } else {
          this.employeeDialogSelected.push(empName)
        }
      } else {
        // Single select - toggle if same name
        if (this.employeeDialogSelected.includes(empName)) {
           this.employeeDialogSelected = []
        } else {
           this.employeeDialogSelected = [empName]
        }
      }
    },
    removeSelectedEmployee(empName) {
      var idx = this.employeeDialogSelected.indexOf(empName)
      if (idx >= 0) {
        this.employeeDialogSelected.splice(idx, 1)
      }
    },
    confirmEmployeeSelection() {
      if (this.employeeDialogMode === 'assigned') {
        this.datasets.assigned = this.employeeDialogSelected.length > 0 ? this.employeeDialogSelected[0] : ''
      } else if (this.employeeDialogMode === 'suggestion') {
        this.datasets.suggestion = this.employeeDialogSelected.join('; ')
      } else if (this.employeeDialogMode === 'memberNotification') {
        this.datasets.memberNotification = [...this.employeeDialogSelected]
      } else if (this.employeeDialogMode === 'sales') {
        this.datasets.sales = [...this.employeeDialogSelected]
      }
      this.showEmployeeDialog = false
    },
    buildStatusSteps() {
      this.statusSteps = []
      if (!this.datasets.statusHistory) return
      try {
        var history = typeof this.datasets.statusHistory === 'string'
          ? JSON.parse(this.datasets.statusHistory)
          : this.datasets.statusHistory
        if (!Array.isArray(history)) return
        this.statusSteps = history.map(function(entry) {
          var ts = entry.timestamp ? new Date(entry.timestamp) : null
          var dateStr = ts ? (ts.getFullYear() + '/' + String(ts.getMonth() + 1).padStart(2, '0') + '/' + String(ts.getDate()).padStart(2, '0')) : ''
          var timeStr = ts ? (String(ts.getHours()).padStart(2, '0') + ':' + String(ts.getMinutes()).padStart(2, '0')) : ''
          return {
            label: entry.status || '',
            color: entry.color || '#9E9E9E',
            name: entry.employeeName || '',
            date: dateStr,
            time: timeStr,
            feedback: entry.feedback || '',
            files: Array.isArray(entry.files) ? entry.files : []
          }
        })
      } catch (e) {
        console.error('Failed to parse statusHistory:', e)
      }
    },
    triggerStatusTrackUpload() {
      this.$nextTick(() => {
        if (this.$refs.statusTrackFileInput) {
          this.$refs.statusTrackFileInput.click()
        }
      })
    },
    openStatusTrackDialog() {
      // Use current time as createTime for the new entry
      var now = new Date()
      var pad = function(n) { return String(n).padStart(2, '0') }
      var createTimeStr = now.getFullYear() + '/' + pad(now.getMonth() + 1) + '/' + pad(now.getDate()) + ' ' + pad(now.getHours()) + ':' + pad(now.getMinutes())
      this.statusTrackData = {
        createTime: createTimeStr,
        status: '',
        feFeedbackReport: '',
        files: []
      }
      this.statusTrackPreviews = []
      this.showStatusTrackDialog = true
    },
    handleStatusTrackFileUpload(event) {
      const files = Array.from(event.target.files) // capture as static array BEFORE clearing
      event.target.value = ''
      if (!files.length) return

      this.isUploadingTrackFile = true
      var self = this
      var uploadPromises = Array.from(files).map(function(file) {
        var formData = new FormData()
        formData.append('file', file)
        // Upload to dedicated StatusTrack subfolder
        var idFolder = self.datasets.caseId || self.datasets.id || 'Temp'
        return self.$http.post(`/S3/JobAssignment/Upload?subFolder=${idFolder}/StatusTrack`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(function(response) {
          var data = response.data?.Data || response.data?.data || response.data || {}
          var fileName = data.fileName || data.FileName || file.name
          var idFolder = self.datasets.caseId || self.datasets.id || 'Temp'
          var fullKey = data.key || data.Key || (`JobAssignment/${idFolder}/StatusTrack/${fileName}`)
          // Store fullKey for persistence in statusHistory
          self.statusTrackData.files.push(fullKey)
          // Build preview object with url, fileName, key, isImage (we store fullKey to ensure consistency)
          var previewUrl = data.preSignedUrl || data.PreSignedUrl || data.publicUrl || ''
          var ext = fullKey.split('.').pop().toLowerCase()
          var isImage = ['jpg','jpeg','png','gif','bmp','webp','svg'].includes(ext)
          if (previewUrl) {
            self.statusTrackPreviews.push({ url: previewUrl, fileName: fullKey, key: fullKey, isImage: isImage })
          } else if (isImage) {
            var reader = new FileReader()
            reader.onload = function(e) {
              self.statusTrackPreviews.push({ url: e.target.result, fileName: fullKey, key: fullKey, isImage: true })
            }
            reader.readAsDataURL(file)
          } else {
            // Non-image: show file icon without URL
            self.statusTrackPreviews.push({ url: '', fileName: fullKey, key: fullKey, isImage: false })
          }
        })
      })

      Promise.allSettled(uploadPromises).then(function(results) {
        if (results.some(function(r) { return r.status === 'rejected' })) {
          self.$refs.ShowMsg.open(0, '上傳失敗', '部分檔案上傳失敗，請重試')
        }
        self.isUploadingTrackFile = false
      })
    },

    removeStatusTrackFile(idx) {
      var item = this.statusTrackPreviews[idx]
      if (!item) return
      // Delete from S3 immediately (best-effort, ignore errors)
      var s3Key = item.key || ('JobAssignment/StatusTrack/' + item.fileName)
      if (s3Key) {
        this.$http.post('/S3/JobAssignment/Delete', null, { params: { key: s3Key } }).catch(function() {})
      }
      // Remove from preview list
      this.statusTrackPreviews.splice(idx, 1)
      // Remove from statusTrackData.files
      var fIdx = this.statusTrackData.files.indexOf(item.fileName)
      if (fIdx >= 0) this.statusTrackData.files.splice(fIdx, 1)
    },

    saveStatusTrack() {
      if (!this.statusTrackData.status || !this.statusTrackData.feFeedbackReport || !this.statusTrackData.files.length) {
        this.$refs.ShowMsg.open(0, this.$t('__requiredTitle'), this.$t('__requiredContent'))
        return
      }

      // Build new statusHistory entry
      var empName = sessionStorage.getItem('manageMemberName') || ''
      var empId = sessionStorage.getItem('manageMemberSysId') || ''

      // Find the color for the selected status from trackStatusList items
      var selectedColor = '#9E9E9E'
      var matchedStatus = this.trackStatusList.find(item => item.value === this.statusTrackData.status)
      if (matchedStatus && matchedStatus.color) {
        selectedColor = matchedStatus.color
      }

      var newEntry = {
        status: this.statusTrackData.status,
        employeeId: empId,
        employeeName: empName,
        color: selectedColor,
        feedback: this.statusTrackData.feFeedbackReport || '',
        files: this.statusTrackData.files.slice(), // 複製已上傳的檔案名稱
        timestamp: new Date().toISOString()
      }

      // Parse existing statusHistory and append new entry
      var history = []
      try {
        if (this.datasets.statusHistory) {
          history = typeof this.datasets.statusHistory === 'string'
            ? JSON.parse(this.datasets.statusHistory)
            : this.datasets.statusHistory
        }
      } catch (e) {
        console.error('Failed to parse existing statusHistory:', e)
      }
      if (!Array.isArray(history)) history = []
      history.push(newEntry)

      // Update datasets with new statusHistory as JSON string
      this.datasets.statusHistory = JSON.stringify(history)

      // Sync top-level status with the latest entry
      this.datasets.status = newEntry.status

      // Re-render status steps
      this.buildStatusSteps()

      // Close dialog
      this.showStatusTrackDialog = false
    },
    exportPdf(id, caseId, isClosed = false) {
      if (!id) return
      const url = isClosed ? '/ExportClosedServiceReportPdf' : '/ExportServiceReportPdf'
      var request = {
        method: 'GET',
        url: url,
        params: { id: id, caseId: caseId },
        responseType: 'blob',
      }
      var self = this
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/pdf' })
        var urlObj = window.URL.createObjectURL(blob)
        var link = document.createElement('a')
        link.href = urlObj
        const fileName = isClosed ? 'ServiceReport_' : 'ServiceReport_'
        link.setAttribute('download', fileName + caseId + '.pdf')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(urlObj)
      }).catch((error) => {
        console.error('Export PDF error:', error)
        alert('PDF 匯出失敗')
      })
    },
    fetchCustomerHistory(customerName) {
      this.isLoading = true
      var self = this
      this.$http.get('/GetCustomerJobAssignments', { params: { customerName: customerName } }).then(function(response) {
        var data = response.data.Data || response.data.data || response.data || []
        if (Array.isArray(data)) {
          self.historyList = data.map(function(item) {
            return {
              id: item.id,
              createTimeString: item.createTimeString,
              issue: item.issue || '',
              closeDateString: item.closeDateString,
              feFeedbackReport: item.feFeedbackReport || ''
            }
          })
        } else {
          self.historyList = []
        }
      }).catch(function(error) {
        console.error('Failed to fetch customer history:', error)
        self.historyList = []
      }).finally(function() {
        self.isLoading = false
      })
    },
    formatDateTime(timestamp) {
      if (!timestamp) return ''
      var ts = new Date(timestamp)
      if (isNaN(ts.getTime())) return timestamp
      var pad = function(n) { return String(n).padStart(2, '0') }
      return ts.getFullYear() + '/' + pad(ts.getMonth() + 1) + '/' + pad(ts.getDate()) + ' ' + pad(ts.getHours()) + ':' + pad(ts.getMinutes())
    },
    openStepPreview(step) {
      this.stepPreviewData = Object.assign({}, step)
      this.stepPreviewFileUrls = []
      this.showStepPreviewDialog = true

      if (!step.files) return
      var files = this.deepParse(step.files)
      if (!Array.isArray(files) || files.length === 0) return

      // Fetch S3 pre-signed URLs for each file
      this.isLoadingStepFiles = true
      var self = this
      var promises = files.map(function(item) {
        var storedKey = typeof item === 'object' && item !== null ? (item.filePath || '') : String(item)
        if (!storedKey) return Promise.resolve({ url: '', name: '', isImage: false })

        // Clean up any potential JSON artifacts from legacy or double-encoded data
        if (typeof storedKey === 'string' && (storedKey.includes('"') || storedKey.includes('}') || storedKey.includes(']'))) {
           try {
             var attempt = self.deepParse(storedKey)
             if (typeof attempt === 'object' && attempt !== null && !Array.isArray(attempt)) {
               storedKey = attempt.filePath || storedKey
             } else if (Array.isArray(attempt) && attempt.length > 0) {
               var first = attempt[0]
               storedKey = (typeof first === 'object' && first !== null) ? (first.filePath || '') : String(first)
             }
           } catch(e) {}
           // Final fallback: strip trailing artifacts
           storedKey = String(storedKey).replace(/["}\]]+$/, '')
        }

        var isFullKey = storedKey.includes('/') && !storedKey.startsWith('{') && !storedKey.startsWith('[')
        var params = isFullKey
          ? { fileName: storedKey.split('/').pop(), subFolder: storedKey.split('/').slice(1, -1).join('/') }
          : { fileName: storedKey, subFolder: 'StatusTrack' }
        return self.$http.get('/S3/JobAssignment/Get', {
          params: params
        }).then(function(response) {
          var data = response.data?.Data || response.data?.data || response.data || {}
          var url = data.preSignedUrl || data.PreSignedUrl || data.publicUrl || ''
          var ext = storedKey.split('.').pop().toLowerCase()
          var imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
          return { url: url, name: storedKey, isImage: imageExts.includes(ext) }
        }).catch(function() {
          return { url: '', name: storedKey, isImage: false }
        })
      })

      Promise.all(promises).then(function(results) {
        self.stepPreviewFileUrls = results.filter(function(r) { return r.url })
        self.isLoadingStepFiles = false
      })
    },
    openFileFullscreen(item) {
      this.fullscreenItem = item
      this.showFullscreenDialog = true
    },
    copyToClipboard(text) {
      if (!text || text === '-') return
      navigator.clipboard.writeText(text).then(() => {
        // Silently copy without popup
      }).catch(err => {
        console.error('Copy failed:', err)
      })
    },
    filterGuidName(name) {
      if (!name) return ''
      var displayName = name.includes('/') ? name.split('/').pop() : name
      return displayName.replace(/_[a-zA-Z0-9]{32}(?=\.[^.]+$)/, '')
    },
    checkWarrantyStatus(serialNumber) {
      if (!serialNumber) {
        this.warrantyStatus = null
        return
      }
      var self = this
      this.$http.get('/CheckDeviceMaintenanceStatus', { params: { serialNumber: serialNumber } }).then(function(response) {
        var resObj = response.data
        if (resObj && resObj.Data) {
          self.warrantyStatus = resObj.Data
        } else if (resObj && resObj.data) {
          self.warrantyStatus = resObj.data
        } else {
          self.warrantyStatus = null
        }
      }).catch(function(error) {
        console.error('Check warranty error:', error)
        self.warrantyStatus = null
      })
    }
  }
}
</script>

<style scoped>
#box {
  background-color: #fff;
  border-radius: 8px;
}

/* Consistent row spacing for form fields */
#box .form-row {
  margin-bottom: 2px !important;
}

.form-row-spacing {
  margin-bottom: 2px !important;
}


/* Pic/Video box */
.pic-video-container {
  display: flex;
  align-items: center;
}
.pic-video-box {
  border: 1px solid #ccc;
  border-radius: 12px;
  min-height: 120px;
  padding: 12px;
  background-color: #fff;
}
.pic-thumb-wrap {
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.pic-thumb-wrap:hover {
  transform: scale(1.05);
}
.pic-thumb-del {
  position: absolute;
  top: -8px;
  right: -8px;
  background: white !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}
.status-container {
  display: flex;
  margin-left: 30px;
  align-items: flex-start;
  overflow-x: auto;
  padding: 0px 20px;
  background-color: transparent;
}
.status-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-width: 100px;
}
.status-bubble-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  height: 30px;
}
.step-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 3px solid #fff;
  box-shadow: 0 0 0 1px #999;
  z-index: 2;
}
.step-line {
  position: absolute;
  top: 15px;
  left: 60px;
  width: 80px;
  border-top: 2px dotted #999;
  z-index: 1;
}
.step-label {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
}
.step-info-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80px;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 5px;
  background: white;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}
.step-name {
  color: white;
  font-size: 9px;
  width: 100%;
  text-align: center;
  padding: 1px 2px;
  font-weight: bold;
}
.step-date-time {
  font-size: 9px;
  color: #444;
  text-align: center;
  line-height: 1.1;
  padding: 2px 0;
}
.bubble-plus-btn {
  margin-top: 40px;
}

/* Step clickable hover effect */
.step-clickable {
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease;
}
.step-clickable:hover {
  transform: translateY(-3px);
  opacity: 0.85;
}
.step-clickable:active {
  transform: translateY(0);
}

/* Attachment badge on step */
.step-attachment-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background-color: rgba(0,0,0,0.35);
  border-radius: 6px;
  padding: 1px 4px;
  font-size: 9px;
  color: white;
  font-weight: 600;
  width: 100%;
  text-align: center;
}

/* Step preview thumbnail */
.step-preview-thumb {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  border-radius: 6px;
}
.step-preview-thumb:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.under-warranty-badge {
  color: white;
  font-size: 14px;
  padding: 9px 12px;
  border-radius: 8px;
  font-weight: bold;
  display: inline-block;
  background-color: #9E9E9E; /* default gray */
}
.under-warranty-badge.active {
  background-color: #4CAF50 !important; /* Green */
}
.under-warranty-badge.expired {
  background-color: #F44336 !important; /* Red */
}
.under-warranty-badge.upcoming {
  background-color: #FF9800 !important; /* Orange */
}
.history-table thead th {
  background-color: #F5F5F5 !important;
  color: #333 !important;
  font-size: 14px !important;
}
.history-table tbody td {
  font-size: 14px !important;
  color: #555 !important;
}
.history-table tbody tr {
  background-color: #FFF8F1 !important;
}
.history-table tbody tr:hover {
  background-color: #FFF3E6 !important;
}
.pt14 {
    font-size: 14px;
}
.start {
    color: red;
    margin-right: 3px;
}

.dialog-btn {
  width: 150px;
  margin: 0px 6px;
  border-radius: 8px;
}

.status-track-preview-box {
  border-radius: 8px !important;
  border: 1px solid #999 !important;
}
.status-track-file-input-row{
  border: 2px solid #ED6D00 !important;
  border-radius: 8px !important;
}
.status-track-file-input-row .status-track-file-placeholder {
  height: 40px;
  text-align: start;
  font-size: 13px; 
  line-height: 24px;
  background-color: #fff;
  color: #999;
  border-radius: 8px 0px 0px 8px !important;
}

.clickable-field:hover {
  border-color: #ED6D00 !important;
}
.clickable-field .v-input__slot:hover {
  background-color: #FFF8F0 !important;
}

/* Employee dialog table - match Configuration page style */
.employee-dialog-table thead tr {
  background: #FFFFFF !important;
}
.employee-dialog-table thead th {
  background-color: transparent !important;
  color: #333 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  border-bottom: 2px solid #ED6D00 !important;
}
.employee-dialog-table tbody td {
  font-size: 13px !important;
  color: #555 !important;
}
.emp-selected-row {
  background-color: #FFF3E0 !important;
}
.emp-selected-row:hover {
  background-color: #FFE0B2 !important;
}

/* Pic/Video thumbnail with delete overlay */
.pic-thumb-wrap {
  position: relative;
  display: inline-flex;
}
.pic-thumb-del {
  position: absolute !important;
  top: -6px;
  right: -6px;
  background: white !important;
  border-radius: 50% !important;
}

/* Tooltip Styling */
.contact-tooltip {
  opacity: 1 !important;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
  border-radius: 12px !important;
  padding: 0 !important;
  border: 1px solid #eee !important;
}
.contact-tooltip-content {
  color: #444;
  min-width: 220px;
  background-color: white !important;
}
.tooltip-header {
  font-size: 16px;
  color: #444;
  text-align: center;
  padding: 4px 12px;
}
.tooltip-item {
  font-size: 14px;
  padding: 4px 12px;
}
.tooltip-item span {
  word-break: break-all;
}
.selectable-text {
  user-select: text !important;
  cursor: text;
}
.clickable-tooltip-item {
  cursor: pointer !important;
  transition: background-color 0.2s;
  border-radius: 6px;
}
.clickable-tooltip-item:hover {
  background-color: #f0f0f0;
}
.text_field >>> .v-input__slot {
  min-height: 36px !important;
}
</style>
